var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Chip.module.scss';
import { CloseDark, CloseLight } from '../../../../assets/icons';
var Chip = function (_a) {
    var label = _a.label, value = _a.value, removeable = _a.removeable, bordered = _a.bordered, primary = _a.primary, danger = _a.danger, warning = _a.warning, className = _a.className, onRemove = _a.onRemove;
    var classes = "".concat(primary ? styles.Primary : '', " ").concat(danger ? styles.Danger : '', " ").concat(warning ? styles.Warning : '', " ").concat(bordered ? styles.Bordered : '');
    var onChipRemove = function (e) {
        value && (onRemove === null || onRemove === void 0 ? void 0 : onRemove(value));
        e.stopPropagation();
    };
    var renderClose = function () {
        var isDefault = !primary && !danger && !warning;
        var Close = isDefault || bordered ? CloseDark : CloseLight;
        return (_jsx("i", __assign({ className: styles.Close, onClick: onChipRemove, "data-testid": 'chip-remove' }, { children: _jsx(Close, {}) })));
    };
    return (_jsxs("li", __assign({ className: "".concat(styles.Chip, " ").concat(classes, " ").concat(className ? className : '') }, { children: [label, removeable && renderClose()] })));
};
Chip.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    removeable: PropTypes.bool,
    bordered: PropTypes.bool,
    primary: PropTypes.bool,
    danger: PropTypes.bool,
    warning: PropTypes.bool,
    className: PropTypes.string,
    onRemove: PropTypes.func,
};
Chip.defaultProps = {
    className: '',
};
export { Chip };
//# sourceMappingURL=Chip.js.map